import { render, staticRenderFns } from "./registerDia.vue?vue&type=template&id=e183c664&scoped=true&"
import script from "./registerDia.vue?vue&type=script&lang=js&"
export * from "./registerDia.vue?vue&type=script&lang=js&"
import style0 from "./registerDia.vue?vue&type=style&index=0&id=e183c664&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e183c664",
  null
  
)

export default component.exports